import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { AuthContextValue } from '@/lib/auth';

export interface RouterContext { auth: AuthContextValue; queryClient: QueryClient }

export const Route = createRootRouteWithContext<RouterContext>()({ component: () => <Outlet /> });
